import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import UserGroupSvg from '@/assets/UserGroup.svg';

const Team = ({ size, variant, className }: IconProps) => (
  <img
    src={UserGroupSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default Team;
